const initialState = {
  isLogin: false,
  user: null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_LOGIN":
      return {
        ...state,
        isLogin: action.payload,
      };
    case "SET_USER":
      return {
        ...state,
        user: action.payload,
      };

    case "RESET_USER":
      return (state = initialState);
    default:
      return state;
  }
};

export default userReducer;
